<div class="navBar">
  <div class="navBar-btn">
    <button (click)="backToTransaction()" class="backToReport">
      <mat-icon>keyboard_arrow_left</mat-icon>
      <span>{{ "reports.backToReport" | translate }}</span>
    </button>
  </div>

  <div
    class="property-detailMenu"
    *ngIf="visibleMenuList.length > 0"
    [ngClass]="{ 'property-detailMenuAr': currentReportView === 2 }"
  >
    <app-report-sub-menu
      [menuList]="visibleMenuList"
      [isPropertyDetailPage]="true"
      (menuChangeValue)="menuChangeValue($event)"
    ></app-report-sub-menu>
  </div>
</div>
<div
  class="proj-detail-tabsection"
  id="{{ menuEnum.overview }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.overview }"
>
  <div class="project-detail">
    <!-- Overview -->
    <app-project-detail-overview
      [projectUid]="projectUid"
    ></app-project-detail-overview>
  </div>
</div>
<!-- Project Detail Page -->
<app-municipal-regulations *ngIf="landParceldata[0]?.parcel_uid"
  [landParcelData]="landParceldata"
  [selectedParcelUid]="landParceldata[0]?.parcel_uid">
</app-municipal-regulations>
<!-- Land Parcel Table -->
<div
  class="proj-detail-tabsection"
  id="{{ menuEnum.landParcelTable }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.landParcelTable }"
>
  <!-- <app-report-year-dropdown [reportType]="'unit'" (selectedYear)="selectedYear($event)"></app-report-year-dropdown> -->
  <div class="report-model">
    <app-datatable-title
      [title]="'reports.landParcelTable'"
      [count]="landParcelCount"
      [countTitle]="'reports.totalParcels'"
    ></app-datatable-title>

    <!-- <app-report-datatable class="unitTransaction-table" [showLoader]="!landParcelLoading"
            [tableColumns]="landParcelColumns" [dataLength]="landParcelCount" [tableData]="landParceldata"
            [allowExcelDownload]="true" [showEstaterText]="true" (pageEvent)="onPageEvent($event, 'landParcel')"
            (sort)="sortData($event, 'landParcel')" (excelDownload)="downloadExcel($event, 'project_details_land_parcel', 'a')"
            [downloadLoading]="downloadLoading['a']">
        </app-report-datatable> -->

    <app-property-land-parcel
      [showLoader]="!landParcelLoading"
      [tableColumns]="landParcelColumns"
      [dataLength]="landParcelCount"
      [tableData]="landParceldata"
      [allowExcelDownload]="true"
      [showEstaterText]="true"
      (pageEvent)="onPageEvent($event, 'landParcel')"
      (sort)="sortData($event, 'landParcel')"
      (excelDownload)="
        downloadExcel($event, 'project_details_land_parcel', 'a')
      "
      [downloadLoading]="downloadLoading['a']"
    >
    </app-property-land-parcel>
  </div>
</div>

<!-- Property Details - houses -->
<div *ngIf="propertyHousesdata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.propertyDetailsHouses }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.propertyDetailsHouses }"
  [ngStyle]="{ display: propertyHousesCount ? 'block' : 'none' }"
>
  <!-- <app-report-year-dropdown [reportType]="'unit'" (selectedYear)="selectedYear($event)"></app-report-year-dropdown> -->
  <div class="report-model">
    <app-datatable-title
      [title]="'reports.propertyDetailsHouses'"
      [count]="propertyHousesCount"
      [countTitle]="'reports.totalHouses'"
    ></app-datatable-title>

    <app-report-datatable
      class="unitTransaction-table"
      [showLoader]="!propertyHousesLoading"
      [tableColumns]="propertyHousesColumns"
      [dataLength]="propertyHousesCount"
      [tableData]="propertyHousesdata"
      [allowExcelDownload]="true"
      [showEstaterText]="true"
      (pageEvent)="onPageEvent($event, 'propertyHouses')"
      (sort)="sortData($event, 'propertyHouses')"
      (excelDownload)="
        downloadExcel($event, 'project_details_property_houses', 'b')
      "
      [downloadLoading]="downloadLoading['b']"
      (lastClickedTable)="lastClickedTable($event, 'propertyHouses')"
      [ngClass]="{ activeTable: tableName == 'propertyHouses' }"
      [reportSectionTitle]="'Property Details - Houses'"
      [warehouse_report]="isWarehouseReport"
    >
    </app-report-datatable>
  </div>
</div>

<!-- Property Details - Others -->
<div *ngIf="propertyOthersdata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.propertyDetailsOthers }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.propertyDetailsOthers }"
>
  <!-- <app-report-year-dropdown [reportType]="'unit'" (selectedYear)="selectedYear($event)"></app-report-year-dropdown> -->
  <div class="report-model">
    <app-datatable-title
      [title]="'reports.propertyDetailsOthers'"
      [count]="propertyOthersCount"
      [countTitle]="'reports.totalProperties'"
    ></app-datatable-title>

    <app-report-datatable
      class="unitTransaction-table"
      [showLoader]="!propertyOthersLoading"
      [tableColumns]="propertyOthersColumns"
      [dataLength]="propertyOthersCount"
      [tableData]="propertyOthersdata"
      [allowExcelDownload]="true"
      [showEstaterText]="true"
      (pageEvent)="onPageEvent($event, 'propertyOthers')"
      (sort)="sortData($event, 'propertyOthers')"
      (excelDownload)="
        downloadExcel($event, 'project_details_property_others', 'c')
      "
      [downloadLoading]="downloadLoading['c']"
      (lastClickedTable)="lastClickedTable($event, 'propertyOthers')"
      [ngClass]="{ activeTable: tableName == 'propertyOthers' }"
      [reportSectionTitle]="'Property Details - Others'"
      [warehouse_report]="isWarehouseReport"
    >
    </app-report-datatable>
  </div>
</div>
<!-- Land Prices -->
<div *ngIf="projectLandPriceDetailsdata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.landPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.landPrices }"
>
  <div class="report-model">
  <div class="report-model-header">
     <div class="info w-72">
     <h3>{{"reports.landprices" | translate}}</h3>
    <span class="totalTransaction">({{projectLandActualCount}} {{" "+("reports.actual_transactions_with" |translate)+" "}}
    {{ projectLandEstimatedCount }} {{" "+("reports.quotes" | translate)}}
    {{"reports.And" | translate}}
     {{ projectLandAuctionCount }} {{" "+("reports.auctions" | translate)}}) </span>
     </div>
     </div>

    <app-project-land-prices
      [tableData]="projectLandPriceDetailsdata"
      [tableColumns]="landPricesColumns"
      [showLoader]="!projectLandPriceDetailsLoading"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'project_details_land_price', 'd')"
      [downloadLoading]="downloadLoading['d']"
      [showEstaterText]="true"
      [tableName]="'projLandPrice'"
      [dataLength]="projectLandPriceDetailsCount"
      (pageEvent)="onPageEvent($event, 'projLandPrice')"
      (sort)="sortData($event, 'projLandPrice')"
    ></app-project-land-prices>
  </div>
</div>
<!-- Land Prices -->
<div class="proj-detail-tabsection" *ngIf="chartSection.chart1"
id="{{ menuEnum.landPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.landPrices }">
  <div class="report-model">
    <ng-container>
      <app-land-price-analysis
        [dropdownLabel]="'reports.pleaseSelectZoning'"
        [SectionId]="'landPrice'"
        [graphData]="getLandPriceGraphData"
        [chartTitle]="'reports.landPricesAnalysis'"
        [reportType]="'price'"
        (filterChartdata)="chatSelectionChange($event, 'chart1')"
      ></app-land-price-analysis>
    </ng-container>
  </div>
</div>

<!-- Property Prices  -->
<div *ngIf="projectPropertyPriceDetailsdata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.propertyPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.propertyPrices }"
>

  <div class="report-model" >
  <div class="report-model-header">
     <div class="info w-72">
     <h3>{{"reports.property_prices" | translate}}</h3>
    <span class="totalTransaction">({{projectPropertyPriceActualCount}} {{" "+("reports.actual_transactions_with" |translate)+" "}}
    {{ projectPropertyPriceEstimatedCount }} {{" "+("reports.quotes" | translate)}}
    {{"reports.And" | translate}}
     {{ projectPropertyPriceAuctionCount }} {{" "+("reports.auctions" | translate)}}) </span>
     </div>
     </div>

    <app-project-land-prices
      [tableData]="projectPropertyPriceDetailsdata"
      [tableColumns]="propertyPricesColumns"
      [showLoader]="!projectPropertyPriceDetailsLoading"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'project_details_property_price', 'e')"
      [downloadLoading]="downloadLoading['e']"
      [showEstaterText]="true"
      [tableName]="'projectPropertyPrices'"
      [dataLength]="projectPropertyPriceDetailsCount"
      (pageEvent)="onPageEvent($event, 'projectPropertyPrices')"
       (sort)="sortData($event, 'projLandPrice')"
    ></app-project-land-prices>
  </div>
</div>

<!-- House Price Analysis getPropertyPriceGraphData  -->
<div
  class="proj-detail-tabsection" *ngIf="chartSection.chart2"
  id="{{ menuEnum.propertyPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.propertyPrices }"
>
  <div class="report-model">
  <ng-container>
  <app-land-price-analysis
    [dropdownLabel]="'reports.pleaseSelectZoning'"
    [SectionId]="'housePriceAnalysis'"
    [graphData]="getPropertyPriceGraphData"
    [chartTitle]="'reports.housePriceAnalysis'"
    [reportType]="'price'"
    (filterChartdata)="chatSelectionChange($event, 'chart2')">
  </app-land-price-analysis>
  </ng-container>
  </div>
</div>

<!-- Residential Building Price Analysis  -->
<div class="proj-detail-tabsection" *ngIf="chartSection.chart3"
  id="{{ menuEnum.propertyPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.propertyPrices }"
>
  <div class="report-model">
    <ng-container>
   <app-land-price-analysis
    [dropdownLabel]="'reports.pleaseSelectZoning'"
    [SectionId]="'residentialBuildingPriceAnalysis'"
    [graphData]="getProjectResidentialGraphData"
    [chartTitle]="'reports.residentialBuildingPriceAnalysis'"
     [reportType]="'price'"
     (filterChartdata)="chatSelectionChange($event, 'chart3')">
  </app-land-price-analysis>
  </ng-container>
  </div>
</div>

<!-- Unit Prices  -->
<div *ngIf="projectUnitPriceDetailsdata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.unitPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.unitPrices }"
>
 <div class="report-model" >
  <div class="report-model-header">
     <div class="info w-72">
     <h3>{{"reports.unit_Prices" | translate}}</h3>
    <span class="totalTransaction">({{projectUnitPriceDetailsActualCount}} {{" "+("reports.actual_transactions_with" |translate)+" "}}
    {{ projectUnitPriceDetailsEstimatedCount }} {{" "+("reports.quotes" | translate)}}
    {{"reports.And" | translate}}
     {{ projectUnitPriceDetailsAuctionCount }} {{" "+("reports.auctions" | translate)}}) </span>
     </div>
     </div>
    <app-project-land-prices
      [tableData]="projectUnitPriceDetailsdata"
      [tableColumns]="unitPricesColumns"
      [showLoader]="!projectUnitPriceDetailsLoading"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'project_details_unit_price', 'f')"
      [downloadLoading]="downloadLoading['f']"
      [showEstaterText]="true"
      [tableName]="'projectUnitPrices'"
      [dataLength]="projectUnitPriceDetailsCount"
    ></app-project-land-prices>
  </div>
</div>

<!-- Apartment Price Analysis  -->
<div class="proj-detail-tabsection" *ngIf="chartSection.chart4"
  id="{{ menuEnum.unitPrices }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.unitPrices }"
>
    <div class="report-model">
      <ng-container>
     <app-land-price-analysis
      [dropdownLabel]="'reports.pleaseSelectUnitType'"
      [SectionId]="'apartmentPriceAnalysis'"
      [graphData]="getProjectApartmentGraphData"
      [chartTitle]="'reports.apartmentPriceAnalysis'"
      [reportType]="'price'" 
      (filterChartdata)="chatSelectionChange($event, 'chart4')">
    </app-land-price-analysis>
    </ng-container>
  </div>
</div>

<!--Property Details - Residential Rental -->
<div
  *ngIf="filteredResidentialRentalData.length > 0"
  class="proj-detail-tabsection custom-dropdown-wrapper"
  id="{{ menuEnum.ResidentialRental }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.ResidentialRental }"
  [ngStyle]="{ display: filteredResidentialRentalData ? 'block' : 'none' }"
>
  <div class="report-model report-rentrate">
    <div class="report-model-header">
      <div class="info">
        <h3>
          {{ 'reports.ResidentialRental' | translate }}
        </h3>
      </div>

      <!--Dropdown Button -->
      <button
        class="btn-select-grade"
        [matMenuTriggerFor]="residentialTypeMenu"
        *ngIf="residentialPropertyTypes.length > 0"
      >
        <div class="setext">
         <ng-container *ngFor="let property_grade of selectedResidentialTypes; let last = last">
          {{ property_grade }}<span *ngIf="!last" style="padding-right: 2px;">,</span>
        </ng-container>
        </div>
        <mat-icon>keyboard_arrow_down</mat-icon>
      </button>

      <!--Menu (Same As Retail) -->
      <mat-menu
        #residentialTypeMenu="matMenu"
        [xPosition]="langName === 'ar' ? 'after' : 'before'"
        class="grades-menu-selection directionLtr residential-menu">
        <div (click)="$event.stopPropagation()">
          <h5 class="menu-label">
            {{ "reports.ChooseOptions" | translate }}
          </h5>
      <ng-container *ngFor="let property_grade_key of residentialPropertyTypes">
      <mat-checkbox
    (change)="toggleResidentialType($event, property_grade_key)"
     [checked]="selectedResidentialTypes.includes(property_grade_key)"
   >
      {{ property_grade_key}}
    </mat-checkbox>
      </ng-container>
        </div>
      </mat-menu>
    </div>

    <!-- Residential Rental Table -->
    <app-reports-project-rental-data
      [showLoader]="!residentialrentalLoading"
      [tableColumns]="residentialrentalColumns"
      [tableData]="filteredResidentialRentalData"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'property_detail_residential_rental', 'g')"
      [downloadLoading]="downloadLoading['g']"
      [showEstaterText]="false"
      [tableName]="'residential'"
    ></app-reports-project-rental-data>
  </div>
</div>

<!--chart  Residential Rental -->
  <div class="report-model" *ngIf="chartSection.chart5">
    <ng-container>
      <app-land-price-analysis       
        [SectionId]="'residential'"
        [graphData]="getReasidentialGraphData"
        [chartTitle]="'reports.residentialAnalysis'"
        [sqmLabel]="false"
        [reportType]="'rental'"
        [dropdownLabel]="'reports.pleaseSelectUnitType'"
         (filterChartdata)="chatSelectionChange($event, 'chart5')">
      </app-land-price-analysis>
    </ng-container>
  </div>
<!-- Property Details - Retail Rental -->
<div
  *ngIf="retailRentaldata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.RetailRental }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.RetailRental }"
    [ngStyle]="{ display: retailRentaldata ? 'block' : 'none' }"
>
  <!-- <app-report-year-dropdown [reportType]="'unit'" (selectedYear)="selectedYear($event)"></app-report-year-dropdown> -->
  <div class="report-model">
    <app-datatable-title
      [title]="'reports.RetailRental'"
      [isShowCount]="false"
    ></app-datatable-title>
    <app-reports-project-rental-data
      [showLoader]="!retailRentalLoading"
      [tableColumns]="retailRentalColumns"
      [tableData]="retailRentaldata"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'project_details_retail_rental', 'h')"
      [downloadLoading]="downloadLoading['h']"
      [showEstaterText]="false"
      [tableName]="'retail'"
    ></app-reports-project-rental-data>
  </div>
</div>
<!--chart-->
<div
  class="proj-detail-tabsection" *ngIf="chartSection.chart6"
  id="{{ menuEnum.RetailRental }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.RetailRental }">
  <div class="report-model">
    <ng-container>
      <app-land-price-analysis        
        [SectionId]="'Retail'"
        [graphData]="getRetailGraphData"
        [chartTitle]="'reports.retailAnalysis'"
        [sqmLabel]="true"
        [reportType]="'rental'"
        [dropdownLabel]="'reports.pleaseSelectUnitSize'"
        (filterChartdata)="chatSelectionChange($event, 'chart6')">
      </app-land-price-analysis>
    </ng-container>
  </div>
</div>
<!-- Property Details - Office Rental -->
<div
 *ngIf="officeRentaldata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.OfficeRental }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.OfficeRental }"
   [ngStyle]="{ display: officeRentaldata ? 'block' : 'none' }"
>
  <div class="report-model">
    <app-datatable-title
      [title]="'reports.OfficeRental'"
      [isShowCount]="false"
    ></app-datatable-title>
    <app-reports-project-rental-data
      [showLoader]="!officeRentalLoading"
      [tableColumns]="officeRentalColumns"
      [tableData]="officeRentaldata"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'project_details_office_rental', 'i')"
      [downloadLoading]="downloadLoading['i']"
      [showEstaterText]="false"
      [tableName]="'office'"
    ></app-reports-project-rental-data>
  </div>
</div>

<!--chart-->
  <div class="report-model" *ngIf="chartSection.chart7">
    <ng-container>
      <app-land-price-analysis        
        [SectionId]="'Office'"
        [graphData]="getOfficeGraphData"
        [chartTitle]="'reports.officeAnalysis'"
        [sqmLabel]="true"
        [reportType]="'rental'"
        [dropdownLabel]="'reports.pleaseSelectUnitSize'"
        (filterChartdata)="chatSelectionChange($event, 'chart7')">
      </app-land-price-analysis>
    </ng-container>
  </div>

<!-- Property Details - WareHouse Rental -->
<div
  *ngIf="warehouseRentaldata.length > 0"
  class="proj-detail-tabsection"
  id="{{ menuEnum.WarehouseRental }}"
  [ngClass]="{ scroll: currentScroll === menuEnum.WarehouseRental }"
  [ngStyle]="{ display: warehouseRentaldata ? 'block' : 'none' }"
>
  <div class="report-model">
    <app-datatable-title
      [title]="'reports.WarehouseRental'"
      [isShowCount]="false"
    >
    </app-datatable-title>

    <app-reports-project-rental-data
      [showLoader]="!warehouseRentalLoading"
      [tableColumns]="warehouseRentalColumns"
      [tableData]="warehouseRentaldata"
      [allowExcelDownload]="true"
      (excelDownload)="downloadExcel($event, 'project_details_warehouse_rental', 'j')"
      [downloadLoading]="downloadLoading['j']"
      [showEstaterText]="false"
      [tableName]="'warehouse'"
    >
    </app-reports-project-rental-data>
  </div>
</div>
